import { useContext } from "react"
import { NotificationCenterItem } from "./NotificationCenterItem"
import { NotificationCtx } from "../../context/notificationContext"
import moment from "moment"

export function ListNotifications() {
    const { notifications } = useContext(NotificationCtx)

    const sortedNotifications = notifications.sort(
        (a, b) =>
            moment.utc(b.created_at).toDate().getTime() -
            moment.utc(a.created_at).toDate().getTime()
    )

    if (notifications.length === 0) {
        return (
            <p className="text-base font-bold text-muted-foreground text-center py-4">
                No notifications yet
            </p>
        )
    }

    return (
        <div className="">
            {sortedNotifications.slice(0, 20).map((n) => (
                <NotificationCenterItem
                    key={n.id}
                    notification={n}
                />
            ))}
        </div>
    )
}